import React from "react";
import "./styles/TransactionInfo.css";
import "../components/styles/ModalTransferDetails.css";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import Footer from "../components/Footer";
import ModalWhatSappQr from "../components/ModalWhatSappQr";
import ModalGodiwayer from "../components/ModalGodiwayer";
import UserAvatar from "../components/UserAvatar";
import * as checkoutActions from "../redux/actions/checkoutActions";
import { formatPublicUserId } from "../utils/userPublicUtils";
import {
  FaCheckCircle,
  FaComments,
  FaEnvelope,
  FaPhone,
  FaWhatsapp,
  FaUniversity,
} from "react-icons/fa";
import { Translate, I18n } from "react-redux-i18n";

const KIND_SALE = 2;

function isWhatsappOn(value) {
  return value === "on" || value === 1 || value === true;
}

function getWhatsappNumber(countryPhoneId, phone) {
  const dialCode = String(countryPhoneId || "").replace(/\D/g, "");
  const number = String(phone || "").replace(/\D/g, "");
  if (!dialCode || !number) return "";
  return `${dialCode}${number}`;
}

function ContactDetail({ icon: Icon, label, children }) {
  return (
    <div className="transaction-info-detail">
      <span className="transaction-info-detail__icon" aria-hidden="true">
        <Icon />
      </span>
      <div className="transaction-info-detail__content">
        <span className="transaction-info-detail__label">{label}</span>
        <p className="transaction-info-detail__value">{children}</p>
      </div>
    </div>
  );
}

class TransactionInfo extends React.Component {
  state = {
    open_modal: false,
    open_profile_modal: false,
    number: "",
  };

  componentDidMount() {
    const adId = this.props.ad?.Id;
    if (adId && this.props.token) {
      this.props.LoadCheckout(this.props.user_id, this.props.token, adId);
    }
  }

  seeModal = () => {
    const user = this.props.ad?.User;
    const store = this.props.ad?.UserStore;
    const countryPhoneId = user?.CountryPhoneId || store?.CountryPhoneId;
    const phone = user?.Phone || store?.Phone;
    const cell = getWhatsappNumber(countryPhoneId, phone);

    if (!cell) return;

    this.setState({ open_modal: true, number: cell });
  };

  onClose = () => {
    this.setState({ open_modal: false });
  };

  openProfileModal = () => {
    this.setState({ open_profile_modal: true });
  };

  closeProfileModal = () => {
    this.setState({ open_profile_modal: false });
  };

  isTransferPurchase() {
    const kind = Number(this.props.ad?.KindCommerceId || this.props.seller?.KindCommerceId);
    const payment = this.props.paymentOption || this.props.seller?.PaymentOption || "";
    return kind === KIND_SALE && payment === "transfer";
  }

  renderBankAccounts() {
    const accounts = this.props.bankAccounts || [];

    if (accounts.length === 0) {
      return (
        <p className="transfer-modal__empty">
          <Translate value="checkout_no_banks" />
        </p>
      );
    }

    return (
      <ul className="transfer-modal__list">
        {accounts.map((acc) => (
          <li key={acc.Id} className="transfer-modal__bank">
            <div className="transfer-modal__bank-icon">
              <FaUniversity />
            </div>
            <div className="transfer-modal__bank-body">
              <span className="transfer-modal__bank-name">{acc.Bank}</span>
              <span className="transfer-modal__bank-holder">{acc.HolderName}</span>
              <span className="transfer-modal__bank-number">
                {acc.AccountNumber}
                {acc.AccountType
                  ? " · " + I18n.t("bank_account_type_" + acc.AccountType)
                  : ""}
              </span>
              {acc.Identification ? (
                <span className="transfer-modal__bank-id">{acc.Identification}</span>
              ) : null}
            </div>
            {acc.QrUrl ? (
              <a
                href={acc.QrUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="transfer-modal__bank-qr"
              >
                <img src={acc.QrUrl} alt="QR" />
              </a>
            ) : null}
          </li>
        ))}
      </ul>
    );
  }

  hasSellerConversation() {
    const { seller } = this.props;
    return seller !== undefined && JSON.stringify(seller) !== "{}";
  }

  render() {
    const { ad } = this.props;
    const user = ad?.User || {};
    const country = ad?.Country || {};
    const phoneLada = country.Lada || user.CountryPhoneId || "";
    const whatsappNumber = getWhatsappNumber(user.CountryPhoneId, user.Phone);
    const profileUser = {
      ...user,
      PublicId: user.PublicId || formatPublicUserId(user.Id),
    };
    const username = user.Username ? `@${user.Username}` : "";

    const contact = this.props.contact || {};
    const showPhone = Boolean(contact.Phone && contact.PhoneNumber);
    const showEmail = Boolean(contact.Email && contact.EmailAddress);
    const hasContactConfig = showPhone || showEmail || Boolean(contact.Chat);
    const showWhatsappBtn = showPhone
      ? Boolean(contact.Whatsapp && whatsappNumber)
      : isWhatsappOn(user.Whatsapp) && Boolean(whatsappNumber);

    return (
      <React.Fragment>
        <div className="transaction-info-page">
          <div className="transaction-info-inner">
            <div className="transaction-info-card">
              <header className="transaction-info-hero">
                <span className="transaction-info-hero__icon" aria-hidden="true">
                  <FaCheckCircle />
                </span>
                <h1 className="transaction-info-hero__title">
                  <Translate value="transaction_congratulations" />
                </h1>
                <p className="transaction-info-hero__subtitle">
                  <Translate value="transaction_email_seller" />
                </p>
              </header>

              <section className="transaction-info-seller">
                <button
                  type="button"
                  className="transaction-info-seller__trigger"
                  onClick={this.openProfileModal}
                >
                  <UserAvatar
                    src={user.Avatar}
                    alt={user.Name || "Godiwayer"}
                    verified={user.Verified}
                    user={user}
                    size="lg"
                    imgClassName="transaction-info-seller__avatar"
                    initials={(user.Name || "?").charAt(0).toUpperCase()}
                  />
                  <div className="transaction-info-seller__body">
                    {user.Name && (
                      <h2 className="transaction-info-seller__name">{user.Name}</h2>
                    )}
                    {username && (
                      <p className="transaction-info-seller__username">{username}</p>
                    )}
                  </div>
                </button>

                <div className="transaction-info-seller__contact">
                  {hasContactConfig ? (
                    <div className="transaction-info-details">
                      {showPhone && (
                        <ContactDetail
                          icon={FaPhone}
                          label={<Translate value="profile_phone" />}
                        >
                          {contact.PhoneNumber}
                          {contact.Whatsapp && (
                            <span className="transaction-info-detail__wa">
                              <FaWhatsapp /> WhatsApp
                            </span>
                          )}
                        </ContactDetail>
                      )}

                      {showEmail && (
                        <ContactDetail
                          icon={FaEnvelope}
                          label={<Translate value="profile_email" />}
                        >
                          <a
                            href={`mailto:${contact.EmailAddress}?subject=Godiwayer&body=Equipo%20GodiWay,`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {contact.EmailAddress}
                          </a>
                        </ContactDetail>
                      )}

                      {contact.Chat && (
                        <ContactDetail
                          icon={FaComments}
                          label={<Translate value="contact_method_chat" />}
                        >
                          <Translate value="contact_chat_desc" />
                        </ContactDetail>
                      )}
                    </div>
                  ) : (
                    <div className="transaction-info-details">
                      {user.Phone && (
                        <ContactDetail icon={FaPhone} label={<Translate value="profile_phone" />}>
                          {phoneLada ? `(+${phoneLada}) ` : ""}
                          {user.Phone}
                        </ContactDetail>
                      )}

                      {user.Email && (
                        <ContactDetail icon={FaEnvelope} label={<Translate value="profile_email" />}>
                          <a
                            href={`mailto:${user.Email}?subject=Godiwayer&body=Equipo%20GodiWay,`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {user.Email}
                          </a>
                        </ContactDetail>
                      )}
                    </div>
                  )}
                </div>

                {showWhatsappBtn && (
                  <button
                    type="button"
                    className="transaction-info-whatsapp-btn"
                    onClick={this.seeModal}
                  >
                    <FaWhatsapp />
                    <Translate value="chat_whatsap" />
                  </button>
                )}
              </section>

              {this.isTransferPurchase() && (
                <section className="transaction-info-banks">
                  <h2 className="transaction-info-banks__title">
                    <FaUniversity />
                    <Translate value="checkout_banks_title" />
                  </h2>
                  {this.props.checkoutLoading ? (
                    <p className="transfer-modal__loading">
                      <Translate value="loading" />
                    </p>
                  ) : (
                    this.renderBankAccounts()
                  )}
                </section>
              )}

              <footer className="transaction-info-actions">
                <Link className="transaction-info-btn transaction-info-btn--primary" to="/home">
                  <Translate value="ok" />
                </Link>
                {this.hasSellerConversation() && (
                  <Link
                    to={`/chat/${this.props.seller.ConversationId}`}
                    className="transaction-info-btn transaction-info-btn--secondary"
                  >
                    <FaComments />
                    <Translate value="contact_title" />
                  </Link>
                )}
              </footer>
            </div>
          </div>
        </div>

        <ModalWhatSappQr
          isOpen={this.state.open_modal}
          onClose={this.onClose}
          item={this.state.number}
        />
        <ModalGodiwayer
          isOpen={this.state.open_profile_modal}
          onClose={this.closeProfileModal}
          item={profileUser}
          country={country}
          identityOnly
          showChatAction={false}
        />
        <Footer />
      </React.Fragment>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    ad: reducer.ad.item,
    seller: reducer.transactionPending.seller,
    paymentOption: reducer.transactionPending.paymentOption,
    contact: reducer.checkout.contact,
    bankAccounts: reducer.checkout.bankAccounts,
    checkoutLoading: reducer.checkout.loading,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadCheckout: (user_id, token, goder_id) =>
    dispatch(checkoutActions.loadSellerCheckout({ user_id, token, goder_id })),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TransactionInfo)
);
